export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  quickLink: Maybe<QuickLink>;
};

export type QueryQuickLinkArgs = {
  context: ZalamoObject;
  contextId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}
